import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './landingpage.css';
import Ventajas from './ventajas/ventajas';
import Mision from './empresa/mision';
import Vision from './empresa/vision';
import Preguntas from './preguntasfrecuentes/preguntas';
import Formulario from './formulario/formulario';
import Graduados from './graduados/graduados';
import Testimonios from './testimonios/testimonios';
import Noticias from './noticias/noticias';
import Footer from '../footer/footer';
import OwlFAB from './pet/pet';
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import carga from '../carga/carga';
import GiraYgana from '../../resources/images/gira.png';

function LandingPage({ openFormulario, onSetOpenFormulario }) {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentSocialIndex, setCurrentSocialIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  // Slides con imágenes y videos
  const slides = useMemo(() => [
    {
      type: 'image',
      src: 'https://ensenarteonline.com.co/images/graduados/graduados072026-0.jpeg',
      duration: 8000,
    },
    {
      type: 'video',
      src: 'https://ensenarteonline.com.co/videos/charla.mp4',
    },
    {
      type: 'image',
      src: 'https://ensenarteonline.com.co/images/graduados/graduados072026-1.jpeg',
      duration: 8000,
    },
    {
      type: 'video',
      src: 'https://ensenarteonline.com.co/videos/charlav2.mp4',
    },
    {
      type: 'image',
      src: 'https://ensenarteonline.com.co/images/imagenfondo3.jpg',
      duration: 8000,
    },
    {
      type: 'video',
      src: 'https://ensenarteonline.com.co/videos/leonorrojas.mp4',
    },
    {
      type: 'image',
      src: 'https://ensenarteonline.com.co/images/graduados/WhatsApp Image 2026-08-07 at 12.53.39.jpeg',
      duration: 8000,
    },
    {
      type: 'video',
      src: 'https://ensenarteonline.com.co/videos/perritos.mp4',
    },
  ], []);
  useEffect(() => {
  carga.mostrarCarga();

  const firstImage = new Image();

  firstImage.src = slides[0].src;

  firstImage.onload = () => {
    setIsLoading(false);
    carga.ocultarCarga();
  };

  firstImage.onerror = () => {
    setIsLoading(false);
    carga.ocultarCarga();
  };
}, [slides]);
useEffect(() => {
  const nextIndex = (currentSlide + 1) % slides.length;
  const nextSlide = slides[nextIndex];

  if (nextSlide.type === 'image') {
    const img = new Image();
    img.src = nextSlide.src;
  } else {
    const video = document.createElement('video');
    video.src = nextSlide.src;
    video.preload = 'metadata';
  }
}, [currentSlide, slides]);

  

  // Redes sociales
  const socials = [
    {
      icon: FaFacebookF,
      color: '#1877f2',
      link: 'https://www.facebook.com/EnsenarteOnline',
      label: 'Facebook'
    },
    {
      icon: FaInstagram,
      color: '#dd2a7b',
      link: 'https://www.instagram.com/ensenarte.online',
      label: 'Instagram'
    },
    {
      icon: FaTiktok,
      color: '#000',
      link: 'https://www.tiktok.com/@ensenarte.online',
      label: 'TikTok'
    },
    {
      icon: FaWhatsapp,
      color: '#25d366',
      link: 'https://wa.me/573021233853',
      label: 'WhatsApp'
    },
  ];

  // Configuración de slides
  const slideConfig = {
    0: {
      title: 'Aprende EnseñArte',
      description: 'Descubre técnicas innovadoras y desarrolla tu creatividad con nuestros cursos especializados.',
      action: () => scrollToSection('cursos')
    },
    1: {
      title: 'Crea sin Límites',
      description: 'Únete a una comunidad de artistas y comparte tus obras maestras con el mundo.',
      action: () => onSetOpenFormulario(true)
    },
    2: {
      title: 'Expresa tu Talento',
      description: 'Aprende nuevas técnicas y potencia tus habilidades artísticas.',
      action: () => scrollToSection('testimonios')
    },
  };

  // Auto avance SOLO para imágenes
  useEffect(() => {
    const current = slides[currentSlide];

    if (current.type === 'video') return;

    const timeout = setTimeout(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, current.duration || 8000);

    return () => clearTimeout(timeout);
  }, [currentSlide, slides]);

  // Reproducir video activo inmediatamente y limitar a 15 segundos
  const videoRefs = useRef([]);

  useEffect(() => {
    let timer;

    const current = slides[currentSlide];

    // Pause y resetear todos los videos no activos
    videoRefs.current.forEach((v, i) => {
      if (!v) return;
        if (i !== currentSlide) {
        try {
          v.pause();
        } catch (e) {}
      }
    });

    if (current && current.type === 'video') {
      const video = videoRefs.current[currentSlide];

      if (video) {
        try {
          video.preload = 'metadata';
          video.muted = true;
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        } catch (e) {}

        // Avanza la diapositiva tras 15 segundos
        timer = setTimeout(() => {
          setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 15000);
      }
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [currentSlide, slides]);

  // Bucle redes sociales
  useEffect(() => {
    if (isMenuOpen) return;

    const interval = setInterval(() => {
      setCurrentSocialIndex((prevIndex) =>
        (prevIndex + 1) % socials.length
      );
    }, 2000);

    return () => clearInterval(interval);
  }, [isMenuOpen, socials.length]);

  const handleNextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  };

  const handlePrevSlide = () => {
    setCurrentSlide((prevSlide) =>
      (prevSlide - 1 + slides.length) % slides.length
    );
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const scrollToSection = (id) => {
    const target = document.getElementById(id);

    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });

      window.history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search
      );
    }
  };

  const handleSlideAction = () => {
    const config =
      slideConfig[currentSlide % Object.keys(slideConfig).length];

    if (config?.action) {
      config.action();
    }
  };

  // Loading screen
  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-content">
          <div className="loading-spinner"></div>
          <h2>Cargando EnseñArte...</h2>
          <p>Preparando la mejor experiencia para ti</p>
        </div>
      </div>
    );
  }

  // Sin slides
  if (slides.length === 0) {
    return (
      <section className="landingpage-container">
        <div className="landingpage-wrapper">
          <div className="landingpage-carousel">
            <div className="landingpage-empty-content">
              <div className="landingpage-empty-icon">📸</div>

              <p className="landingpage-empty-title">
                Galería de EnsenArte
              </p>

              <p className="landingpage-empty-text">
                Importa tus imágenes o videos
              </p>

              <p className="landingpage-empty-hint">
                Luego agrégalos al arreglo 'slides'
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="landingpage-container">
        <div className="landingpage-wrapper">

          {/* Carrusel */}
          <div className="landingpage-carousel">

            <div
              className="landingpage-slides"
              style={{
                transform: `translateX(-${currentSlide * 100}%)`
              }}
            >

              {slides.map((slide, index) => (
                <div
                  key={index}
                  className="landingpage-slide"
                >

                  {/* Imagen */}
                  {slide.type === 'image' ? (
                    <img
                      src={slide.src}
                      alt={`Slide ${index + 1}`}
                      loading="lazy"
                    />
                  ) : (
                    <video
                      className="landingpage-video"
                      src={slide.src}
                      ref={(el) => (videoRefs.current[index] = el)}
                      autoPlay={index === currentSlide}
                      muted
                      playsInline
                      preload="none"
                      loading="lazy"
                      onEnded={() =>
                        setCurrentSlide(
                          (prev) => (prev + 1) % slides.length
                        )
                      }
                    />
                  )}

                  {/* Overlay oscuro */}
                  <div className="landingpage-overlay"></div>

                  {/* Contenido */}
                  <div
                    className={`landingpage-slide-content ${
                      index === currentSlide
                        ? 'landingpage-content-active'
                        : ''
                    }`}
                    onClick={() =>
                      index === currentSlide &&
                      handleSlideAction()
                    }
                    style={{
                      cursor:
                        index === currentSlide
                          ? 'pointer'
                          : 'default'
                    }}
                  >

                    <h2
                      className={`landingpage-slide-title ${
                        index === currentSlide
                          ? 'landingpage-title-active'
                          : ''
                      }`}
                    >
                      {
                        slideConfig[
                          index % Object.keys(slideConfig).length
                        ]?.title || `Slide ${index + 1}`
                      }
                    </h2>

                    <p
                      className={`landingpage-slide-description ${
                        index === currentSlide
                          ? 'landingpage-description-active'
                          : ''
                      }`}
                    >
                      {
                        slideConfig[
                          index % Object.keys(slideConfig).length
                        ]?.description ||
                        'Galería EnseñArte'
                      }
                    </p>

                    {slideConfig[
                      index % Object.keys(slideConfig).length
                    ] && (
                      <button
                        className={`landingpage-slide-button ${
                          index === currentSlide
                            ? 'landingpage-button-active'
                            : ''
                        }`}
                        onClick={() => handleSlideAction()}
                      >
                        {(index %
                          Object.keys(slideConfig).length) === 0
                          ? 'Explorar Cursos'
                          : 'Unirse a Comunidad'}
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Controles */}
            {slides.length > 1 && (
              <>
                <button
                  className="landingpage-carousel-control landingpage-carousel-control-prev"
                  onClick={handlePrevSlide}
                  aria-label="Diapositiva anterior"
                >
                  ❮
                </button>

                <button
                  className="landingpage-carousel-control landingpage-carousel-control-next"
                  onClick={handleNextSlide}
                  aria-label="Siguiente diapositiva"
                >
                  ❯
                </button>

                {/* Indicadores */}
                <div className="landingpage-indicators">
                  {slides.map((_, index) => (
                    <button
                      key={index}
                      className={`landingpage-indicator ${
                        index === currentSlide
                          ? 'landingpage-indicator-active'
                          : ''
                      }`}
                      onClick={() => goToSlide(index)}
                      aria-label={`Ir a diapositiva ${index + 1}`}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      {/* Ventajas */}
      <Ventajas />

      {/* Misión & Visión (entre Ventajas y Preguntas) */}
      <Mision />
      <Vision />

      {/* Formulario */}
      {openFormulario && (
        <Formulario
          openForm={openFormulario}
          onClose={() => onSetOpenFormulario(false)}
        />
      )}

      {/* Preguntas */}
      <div id="cursos" />
      <div id="preguntas" />
      <Preguntas />

      {/* Graduados */}
      <div id="graduados" />
      <Graduados />

      {/* Testimonios */}
      <div id="testimonios" />
      <Testimonios />

      {/* Noticias */}
      <div id="noticias" />
      <Noticias />

      {/* Footer */}
      <Footer />

      {/* Redes flotantes */}
      <div className="floating-social-button">

        <button
          className="floating-social-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{
            backgroundColor:
              socials[currentSocialIndex].color,
          }}
        >
          {!isMenuOpen ? (
            React.createElement(
              socials[currentSocialIndex].icon,
              { size: 24 }
            )
          ) : (
            <span>✕</span>
          )}
        </button>

        {/* Menú */}
        {isMenuOpen && (
          <div className="floating-social-menu">

            {socials.map((social, index) => {
              const IconComponent = social.icon;

              return (
                <a
                  key={index}
                  href={social.link}
                  target="_blank"
                  rel="noreferrer"
                  className="floating-social-link"
                  style={{
                    backgroundColor: social.color
                  }}
                  title={social.label}
                >
                  <IconComponent size={20} />
                </a>
              );
            })}
          </div>
        )}
      </div>

  {/* Imagen flotante GiraYgana */}
<div className="floating-gira-image" onClick={() => navigate('/interes')}>
  <img src={GiraYgana} alt="Gira y Gana" className="gira-img" />
</div>

      <OwlFAB />
    </>
  );
}

export default LandingPage;